import CustomDatatable from "./custom-datatable.container";

export default CustomDatatable;
